import { defaultCtx } from "~/lib/AjaxCtx"
import { traverse } from "~/lib/utils"

export function makeDefaultState() {
    return {
        permissions: {
            notifications: [],
            value: false,
        },
        token: "",
    }
}

export const getters = {
    pushNotificationsPermission: (_state, _getters, rootState) => {
        const permission = window.Notification
            ? window.Notification.permission
            : "denied"
        const { enableNotifications, enableServiceWorker } =
            rootState.featureFlags
        return enableNotifications && enableServiceWorker
            ? permission
            : "denied"
    },

    notificationPermission: state => id => {
        let value = false
        function callback(node) {
            if (node.id === id) {
                value = node.value
                return true
            }
        }
        const notifications = state.permissions.notifications
        notifications.some(node => {
            return traverse(node, callback, node => node.children ?? [])
        })
        return value
    },
}

export const mutations = {
    setActive(state, value) {
        state.permissions.value = value
    },

    setToken(state, token) {
        state.token = token
    },

    setNotificationPermissions(state, permissions) {
        state.permissions = permissions
    },

    clearModule(state) {
        state.permissions = {
            value: false,
            notifications: [],
        }
        state.token = ""
    },
}

export function makeActions({ ctx } = {}) {
    return {
        refreshNotificationPermissions({ getters, commit }) {
            const permission = getters.pushNotificationsPermission
            if (permission === "denied") return

            ctx.fetchData("/notifications", {
                waitFor: "/notifications",
            }).then(({ notifications, value }) => {
                commit("setNotificationPermissions", { notifications, value })
            })
        },

        toggleNotificationPermission({ getters, commit, dispatch }, id) {
            const value = !getters.notificationPermission(id)
            return ctx
                .fetchData(`/notifications/${id}`, {
                    method: "PUT",
                    body: JSON.stringify({ value }),
                })
                .then(permissions => {
                    commit("setNotificationPermissions", permissions)
                })
                .catch(error => {
                    dispatch(
                        "pushNotification",
                        {
                            type: "error",
                            title: error.message,
                        },
                        {
                            root: true,
                        }
                    )
                })
        },
    }
}

export default {
    namespaced: true,
    state: makeDefaultState(),
    getters,
    mutations,
    actions: makeActions({ ctx: defaultCtx }),
}
